(function () {
  'use strict';
  class Controller {
    constructor() {}
  }
  angular
    .module('display.detail', [])
    .component('displayDetail', {
      controller: Controller,
      templateUrl: 'root/display/_components/detail/detail-display.comp.html',
      bindings: {
        form: '&',
        display: '<'
      }
    });
}());
